import { render } from "./LogoHSC.vue?vue&type=template&id=3d836e8c"
import script from "./LogoHSC.vue?vue&type=script&lang=js"
export * from "./LogoHSC.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__